import { css } from 'styled-components';

export const ProgressBar = css(({ theme }) => {
  return css`
    margin: 20px auto 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0 50px;
    width: 400px;

    @media only screen and ${theme.device.max.laptopS} {
      width: 90vw;
      margin-top: 10px;
      box-sizing: border-box;
    }

    > .step {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 10px 0;

      > .circle {
        width: 20px;
        height: 20px;
        margin: 0 auto;
        background-color: ${theme.colors.disabledBG};
        border: 2px solid ${theme.colors.disabledBG};
        border-radius: 50%;
        text-align: center;
        line-height: 30px;
        font-size: 16px;
        font-weight: 600;
        box-sizing: border-box;

        z-index: 2;

        &.checked {
          background-color: ${theme.colors.primaryBackground};
          border: 2px solid ${theme.colors.primaryBackground};
        }

        &.done {
          width: 20px;
          background-color: ${theme.colors.primaryBright};
          border: 2px solid ${theme.colors.primaryBright};
        }

        &::before {
          content: attr(data-textbefore);
          display: block;
          margin-top: -7px;
          color: ${theme.colors.mediumGray};
          font-size: 10px;
        }

        &.checked::before {
          content: '';
          display: block;
          transform: rotate(45deg);
          height: 8px;
          width: 3px;
          margin-left: 6px;
          margin-top: 3px;
          border-bottom: 1px solid white;
          border-right: 1px solid white;
        }

        &.done::before {
          color: ${theme.colors.white};
        }
      }

      > .title {
        margin-top: 10px;
        font-size: 10px;
        text-align: center;
        font-weight: ${theme.font.weight.boldest};
        color: transparent;

        &.done {
          color: ${theme.colors.primaryBright};
          font-weight: ${theme.font.weight.bold};
        }

        &.incomplete {
          color: ${theme.colors.primaryBackground};
          font-weight: ${theme.font.weight.bold};
        }
      }
    }

    > .bar {
      height: 0;
      margin-bottom: 25px;
      border-top: 1px solid ${theme.colors.disabledBG};
      width: 100%;
      margin-left: -15px;
      margin-right: -15px;

      &.done {
        border-color: ${theme.colors.primaryBright};
      }
    }
  `;
});
